import { DataWarehouseTracker } from '../data-warehouse';

/**
 * Tracks Open Web impression
 * @returns {void}
 */
export function trackOpenWebImpression(): void {
	/**
	 * Filter for `ads-open-web-detection` will bring up requests to https://beacon.wikia-services.com/__track/special/trackingevent
	 * The impression can be found in Athena in `fact_trackingevent_events_nrt`. _nrt table is updated every 15-30 minutes.
	 */
	const dataWarehouseTracker = new DataWarehouseTracker();

	dataWarehouseTracker.track({
		category: 'ads-open-web-detection',
		action: 'impression',
	});
}
